import { render, staticRenderFns } from "./decorateSearch.vue?vue&type=template&id=52ac9dca&scoped=true&"
import script from "./decorateSearch.vue?vue&type=script&lang=js&"
export * from "./decorateSearch.vue?vue&type=script&lang=js&"
import style0 from "./decorateSearch.vue?vue&type=style&index=0&id=52ac9dca&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ac9dca",
  null
  
)

export default component.exports